<template>
  <div>
    <basic-container>
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>店铺信息:</span>
          </div>
          <el-row>
            <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
            <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
            <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
          </el-row>
        </el-card>
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row>
            <el-col :span="12">
              <!-- 客户信息 -->
              <el-form-item label="客户姓名" prop="customName">
                <el-input v-model="info.customName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户手机号" prop="customMobile">
                <el-input v-model="info.customMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户地址" prop="customAddress">
                <el-input v-model="info.customAddress"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="安装时间" prop="installTime">
                <el-date-picker v-model="info.installTime" type="datetime" @change="handleInstallTimeChange"
                  placeholder="选择安装时间"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col v-if="info.preEmbedded == 'YES' || info.preEmbedded == '是'" :span="12">
              <el-form-item label="预埋" prop="preEmbedded">
                <el-select v-model="info.preEmbedded" placeholder="选择预埋情况" @change="handlePreEmbeddedChange">
                  <el-option label="是" value="YES"></el-option>
                  <el-option label="否" value="NO"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-else :span="24">
              <el-form-item label="预埋" prop="preEmbedded">
                <el-select v-model="info.preEmbedded" placeholder="选择预埋情况" @change="handlePreEmbeddedChange">
                  <el-option label="是" value="YES"></el-option>
                  <el-option label="否" value="NO"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="info.preEmbedded == 'YES' || info.preEmbedded == '是'" :span="12">
              <el-form-item label="管线预埋长度" prop="lineLength">
                <el-input v-model="info.lineLength"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返利人、返利金额 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="返利人">
                <el-input v-model="info.reference"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="返利金额">
                <el-input v-model="info.rebateAmount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="零售价">
                <el-input v-model="info.retailPrice"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label="额外费用支付人" prop="additionalLaborPayer">
                <el-select v-model="info.additionalLaborPayer" placeholder="选择安装额外费用支付人">
                  <el-option label="经销商" value="经销商"></el-option>
                  <el-option label="业主" value="业主"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="picUrl" label="付款凭证">
                <ImageUpload action="#" :multiple="true" :inTable="true" :limit="5" @uploaded="handleUploaded"
                  :uploaded-images="info.picUrl"/>
              </el-form-item>
            </el-col>
            </el-row>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="info.remarks"></el-input>
          </el-form-item>

          <!-- 商品选择表格 -->
          <el-form-item label="商品列表" prop="selectedGoods">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="goodsId" label="商品名称">
                <template slot-scope="scope">
                  <!-- 可搜索 -->
                  <el-select v-model="scope.row.goodsId" placeholder="请选择商品" :disabled="!isEditable(scope.row)"
                    filterable @change="handleGoodsChange(scope.row)">
                    <el-option v-for="goods in goodsList" :key="goods.id" :label="goods.name" :value="goods.id"
                      :disabled="isOptionDisabled(goods.id)"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.num" :min="1" :step="1"
                    :disabled="!isEditable(scope.row)"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-minus" @click="removeGoods(scope.$index)"
                    :disabled="!isEditable(scope.row)">删除商品</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="addGoods"
                    style="margin-top: 10px;">添加商品</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" icon="el-icon-plus" @click="addGoods"
              v-if="selectedGoods.length === 0">添加商品</el-button>
          </el-form-item>
        </el-card>
      </el-form>

      <!-- 提交和返回按钮 -->
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 20px;">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { getMerchantOrder, editMerchantOrder,getGoodList } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      goodsList: [], // 商品列表
      selectedGoods: [], // 用户选择的商品
      info: {
        customName: "",
        customMobile: "",
        customAddress: "",
        installTime: null,
        preEmbedded: "",
        lineLength: "", // 管线预埋长度
        retailPrice: "",
        remarks: ""
      }, // 表单数据
      baseRules: {
        // customName: [{ required: true, message: "请输入客户姓名", trigger: "blur" }],
        // customMobile: [{ required: true, message: "请输入客户手机号", trigger: "blur" }],
        // customAddress: [{ required: true, message: "请输入客户地址", trigger: "blur" }],
        // preEmbedded: [{ required: true, message: "请选择预埋情况", trigger: "change" }],
        // lineLength: [{ required: true, message: "请输入管线预埋长度", trigger: "blur" }],
        // picUrl: [{ required: true, message: "请上传付款凭证", trigger: "blur" }],
        // additionalLaborPayer: [{ required: true, message: "请选择安装额外费用支付人", trigger: "change" }],
      }
    };
  },
  computed: {
    rules() {
      const rules = { ...this.baseRules };
      if (this.info.preEmbedded === 'YES') {
        rules.lineLength = [{ required: true, message: "请输入管线预埋长度", trigger: "blur" }];
      }
      return rules;
    }
  },
  created() {
    const id = this.$route.query.id;

    if (id) {
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          console.log('data::: ', data);
          this.info = data;
          this.info.picUrl = data.picUrl || [];  // 确保 picUrl 存在并赋值
          
          // 当data.list存在时使用，否则调用getGoodList接口获取数据
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            // 调用getGoodList接口获取商品数据
            getGoodList(id).then(res => {
              if (res.code === '200') {
                const goodsData = JSON.parse(res.data);
                this.selectedGoods = goodsData;
                this.processSelectedGoods(goodsData);
              } else {
                this.$message.error('获取商品列表失败');
                // 即使获取失败，也传入空数组以避免后续错误
                this.processSelectedGoods([]);
              }
            }).catch(() => {
              this.$message.error('获取商品列表接口调用失败');
              this.processSelectedGoods([]);
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  methods: {
    handleUploaded(urls) {
      this.info.picUrl = urls;
    },
    // 处理预埋选择变更
    handlePreEmbeddedChange(value) {
      if (value == 'NO') {
        this.info.lineLength = "";
      }
    },
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null;
      }
    },
    // 处理商品列表并回显
    processSelectedGoods(selectedGoods) {
      const type = 'PURE_WATER'
      // 使用导入的API函数
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            // 确保selectedGoods是数组
            if (Array.isArray(selectedGoods)) {
              this.selectedGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId || '',
                declarationId: item.declarationId || '',
                name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : ""
              }));
            } else {
              this.selectedGoods = [];
            }
          } else {
            this.goodsList = [];
            this.selectedGoods = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleGoodsChange(row) {
      // 根据选择的goodsId在goodsList中查找相应的商品
      const selectedGoods = this.goodsList.find(goods => goods.id === row.goodsId);
      if (selectedGoods) {
        // 更新row中的name和goodsId
        row.goodsId = selectedGoods.id;
        row.name = selectedGoods.name;
      } else {
        // 如果未找到匹配的商品，清空name
        row.goodsId = null;
        row.name = '';
      }
    },
    // 动态添加商品
    addGoods() {
      if (this.selectedGoods.length === this.goodsList.length) {
        this.$message({
          showClose: true,
          message: "所有商品都已经选择",
          type: "warning"
        });
        return;
      } else {
        this.selectedGoods.push({ goodsId: null, num: 1 });
      }
    },

    // 移除商品
    removeGoods(index) {
      this.selectedGoods.splice(index, 1);
    },

    // 返回上一步
    goBack() {
      /* let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1); */
      window.close();
    },

    // 判断商品是否可编辑
    isEditable(item) {
      return !item.serviceOrderId;
    },
    // 判断选项是否被禁用
    isOptionDisabled(goodsId) {
      return this.selectedGoods.some(item => item.goodsId === goodsId);
    },
    // 提交表单
    submit() {
      this.info.preEmbedded = this.info.preEmbedded == ("YES" || "是") ? "是" : "否";
      this.info.productName = this.selectedGoods.map((g) => `${g.name}*${g.num}`).join(",");
      this.info.productId = this.selectedGoods.map((g) => g.goodsId).join(",");
      if (Array.isArray(this.info.picUrl)) {
        this.info.picUrl = this.info.picUrl.map(item => item.url).join(",");
      }
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          const submitData = {
            ...this.info,
            list: this.selectedGoods
          };
          if (Array.isArray(submitData.picUrl)) {
            submitData.picUrl = submitData.picUrl.join(',');
          }
          editMerchantOrder(submitData).then(res => {
            if (res.code === "200") {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              // 关闭当前标签页
              localStorage.setItem("needsRefresh", "true");
              window.close();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完整填写必填信息",
            type: "error"
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>